import * as THREE from 'three';
import { getPortalCellCenter } from './portalPair';

export const createBountyTagScene = (scene, surfaceY) => {
  const group = new THREE.Group();
  group.visible = false;
  scene.add(group);
  const material = new THREE.MeshBasicMaterial({
    color: 0xffd46c,
    transparent: true,
    opacity: 0.9,
    depthWrite: false,
    toneMapped: false,
  });
  const ring = new THREE.Mesh(
    new THREE.TorusGeometry(1.02, 0.025, 6, 48),
    material
  );
  ring.rotation.x = Math.PI / 2;
  group.add(ring);
  const positions = [];
  [-1, 1].forEach((x) =>
    [-1, 1].forEach((z) => {
      positions.push(x * 0.78, 0, z * 1.18, x * 1.18, 0, z * 1.18);
      positions.push(x * 1.18, 0, z * 1.18, x * 1.18, 0, z * 0.78);
    })
  );
  const brackets = new THREE.LineSegments(
    new THREE.BufferGeometry().setAttribute(
      'position',
      new THREE.Float32BufferAttribute(positions, 3)
    ),
    new THREE.LineBasicMaterial({ color: 0xffdf8f, toneMapped: false })
  );
  group.add(brackets);
  const canvas = document.createElement('canvas');
  canvas.width = 256;
  canvas.height = 64;
  const context = canvas.getContext('2d');
  if (context) {
    context.font = 'bold 30px monospace';
    context.textAlign = 'center';
    context.fillStyle = '#ffe4a0';
    context.fillText('BOUNTY +3', 128, 43);
    const texture = new THREE.CanvasTexture(canvas);
    texture.colorSpace = THREE.SRGBColorSpace;
    const label = new THREE.Sprite(
      new THREE.SpriteMaterial({
        map: texture,
        transparent: true,
        depthWrite: false,
        toneMapped: false,
      })
    );
    label.position.set(0, 0.12, -1.16);
    label.scale.set(1.65, 0.41, 1);
    group.add(label);
  }
  return {
    update(index, elapsed, reduceMotion) {
      group.visible = Number.isInteger(index) && index >= 0 && index < 25;
      if (!group.visible) return;
      const center = getPortalCellCenter(index);
      group.position.set(center.x, surfaceY + 0.085, center.z);
      material.opacity = reduceMotion
        ? 0.9
        : 0.75 + Math.sin(elapsed * 3) * 0.15;
    },
  };
};
